import React, { useState } from "react";
import styles from "./Inputs.module.scss";

const SelectInput = ({ label, name, value, onChange, options, required = false }) => {
  const [error, setError] = useState("");


  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(e);

    if (required && newValue === "") {
      setError("Error");
    } else {
      setError("");
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      <select
          name={name}
          value={value}
          onChange={handleChange}
          className={`${styles.selectField} ${error ? styles.selectError : ""}`}
        >
          <option value="" disabled>
            {label}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label} 
            </option>
          ))}
        </select>

      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default SelectInput;
